import Vue from 'vue'
import Router from 'vue-router'
import iView from 'iview'

import store from '@/store'

const StatisticsList = () => import('@/views/statistics/List.vue')
const ApplyRequestList = () => import('@/views/apply/ApplyRequestList.vue')
const AttendeeList = () => import('@/views/attendee/AttendeeList.vue')
const TextMessageList = () => import('@/views/message/TextMessageList.vue')
const EmailMessageList = () => import('@/views/message/EmailMessageList.vue')
const ModifyPwd = () => import('@/views/account/ModifyPwd.vue')
const UserList = () => import('@/views/account/UserList.vue')
const OrganizationList = () => import('@/views/account/OrganizationList.vue')
const MeetingList = () => import('@/views/meeting/List.vue')
const MeetingDetail = () => import('@/views/meeting/Detail.vue')
const MeetingDetailView = () => import('@/views/meeting/DetailView.vue')
const MeetingSignSetting = () => import('@/views/meeting/MeetingSignSetting.vue')
const MeetingPoster = () => import('@/views/meeting/Poster.vue')
const SignList = () => import('@/views/meeting/SignList.vue')
const InvoiceList = () => import('@/views/meeting/InvoiceList.vue')
const SignIn = () => import('@/views/meeting/SignIn.vue')
const SignDetail = () => import('@/views/meeting/SignDetail.vue')
const Login = () => import('@/views/Login.vue')
const Main = () => import('@/views/components/Main.vue')

Vue.use(Router)
Vue.use(iView)

async function requiresAuth (to, from, next) {
  if (store.getters.authenticated) {
    next()
  } else if (store.state.token) {
    try {
      await store.dispatch('token2user')
      next()
    } catch (e) {
      // token might be invalid, navigate to login page
      // so that user can re-login
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    }
  } else {
    /* no token, no user */
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  }
}

// 不作为Main组件的子页面展示的页面单独写，如下
export const loginRouter = {
  path: '/login',
  name: 'login',
  component: Login
}

export const otherRouter = {
  path: '/',
  name: 'otherRouter',
  redirect: '/meetings'
}

// 作为Main组件的子页面展示并且在左侧菜单显示的路由写在appRouter里
export const appRouter = [
  {
    path: '/meetings',
    component: Main,
    beforeEnter: requiresAuth,
    children: [
      { path: '', name: 'index', component: MeetingList },
      { path: 'list', name: 'meeting-list', component: MeetingList },
      { path: 'create', name: 'meeting-create', component: MeetingDetail },
      { path: ':id([0-9]+)/detail', name: 'meeting-detail', props: true, component: MeetingDetail },
      { path: ':id([0-9]+)/view', name: 'meeting-view', props: true, component: MeetingDetailView },
      { path: ':meetingId([0-9]+)/sign/setting', name: 'meeting-sign-setting-create', props: true, component: MeetingSignSetting },
      { path: ':meetingId([0-9]+)/sign/setting/:id([0-9]+)', name: 'meeting-sign-setting-detail', props: true, component: MeetingSignSetting },
      { path: ':meetingId([0-9]+)/signs', name: 'sign-list', props: true, component: SignList },
      { path: ':meetingId([0-9]+)/invoices', name: 'invoice-list', props: true, component: InvoiceList },
      { path: ':meetingId([0-9]+)/signs/:id([0-9]+)', name: 'sign-detail', props: true, component: SignDetail },
      { path: ':meetingId([0-9]+)/signIn', name: 'sign-in', props: true, component: SignIn },
      { path: ':id([0-9]+)/poster', name: 'meeting-poster', props: true, component: MeetingPoster }
    ]
  },
  {
    path: '/message',
    component: Main,
    beforeEnter: requiresAuth,
    children: [
      { path: 'emailMessageList', name: 'email-list', component: EmailMessageList },
      { path: 'textMessageList', name: 'text-list', component: TextMessageList }
    ]
  },
  {
    path: '/statistics',
    component: Main,
    beforeEnter: requiresAuth,
    children: [
      { path: 'list', name: 'statistics-meeting-list', component: StatisticsList }
    ]
  },
  {
    path: '/account',
    component: Main,
    beforeEnter: requiresAuth,
    children: [
      { path: 'modifyPwd', name: 'modify-pwd', component: ModifyPwd },
      { path: 'userList', name: 'user-list', component: UserList },
      { path: 'organizationList', name: 'org-list', component: OrganizationList }
    ]
  },
  {
    path: '/attendee',
    component: Main,
    beforeEnter: requiresAuth,
    children: [
      { path: 'list', name: 'attendee-list', component: AttendeeList }
    ]
  },
  {
    path: '/applyRequest',
    component: Main,
    beforeEnter: requiresAuth,
    children: [
      { path: 'list', name: 'apply-request-list', component: ApplyRequestList }
    ]
  }
]

const router = new Router({
  base: process.env.NODE_ENV === 'production' ? '/admin/' : null,
  mode: process.env.NODE_ENV === 'production' ? 'history' : 'hash',
  routes: [
    loginRouter,
    otherRouter,
    ...appRouter
  ]
})

router.beforeEach((to, _, next) => {
  iView.LoadingBar.start()
  next()
})

router.afterEach(() => {
  iView.LoadingBar.finish()
})

export default router



// WEBPACK FOOTER //
// ./src/router.js